import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import ToastNotification from '../../../components/ToastNotification';


function Service_ReportPMS() {

  const [noteType, setNoteType] = useState(null);
  const [issueDate, setIssueDate] = useState('');
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
        const showToast = (msg, bg = 'success') => {
          setToast({ show: true, message: msg, bg });
        };
      const [selectedTechnician, setSelectedTechnician] = useState("");
const [selectedParty, setSelectedParty] = useState("");

  const reportOptions = [
    { value: 'call_detail', label: 'Call Detail' },
       { value: 'employee_performance', label: 'Employee Performance' },
           { value: 'employee_collection', label: 'Employee Collection' },
    { value: 'service_history', label: 'Service History' },
    { value: 'paid_service_call', label: 'Paid Service Call' },
    { value: 'pending_pms_call', label: 'Pending PMS Call ' },
      { value: 'schedule_technician', label: 'Schedule For technician ' },
      { value: 'telecaller_sale', label: 'Telecaller Sale Wise ' },
  ]



const technicians = [...new Map(
  fetchData.map(item => [
    item.technician_id,
    {
      id: item.technician_id,
      name: `${item.employee_first_name || ""} ${item.employee_last_name || ""}`
    }
  ])
).values()];

// const parties = [...new Map(
//   fetchData.map(item => [
//     item.party_name,
//     {
//       id: item.party_id,
//       name: item.party_name
//     }
//   ])
// ).values()];

const parties = [...new Map(
  fetchData
    .filter(i => i.party_id)
    .map(item => [
      item.party_id,
      {
        id: item.party_id,
        name: item.party_name
      }
    ])
).values()];

  const handleSearch = async (e) => {
    e.preventDefault();

 if (!fromDate && !toDate) {
    showToast("Please select a date", 'warning');
    return; 
  }

    try {
      const params = {
        noteType: noteType?.value
      };

      if (noteType?.value === 'service_history') {
        if (fromDate) params.from_date = `${fromDate}T00:00:00`;
        if (toDate) params.to_date = `${toDate}T23:59:59`;
      }

      if (noteType?.value === 'call_detail') {
        if (fromDate) params.from_date = `${fromDate}T00:00:00`;
        if (toDate) params.to_date = `${toDate}T23:59:59`;
      }

         if (noteType?.value === 'employee_collection') {
        if (fromDate) params.from_date = `${fromDate}T00:00:00`;
        if (toDate) params.to_date = `${toDate}T23:59:59`;
      }

      if (noteType?.value === 'paid_service_call') {
        if (fromDate) params.from_date = `${fromDate}T00:00:00`;
        if (toDate) params.to_date = `${toDate}T23:59:59`;
      }

    if (noteType?.value === 'pending_pms_call') {
        if (fromDate) params.from_date = `${fromDate}T00:00:00`;
        if (toDate) params.to_date = `${toDate}T23:59:59`;
      }

       if (noteType?.value === 'schedule_technician') {
        if (fromDate) params.from_date = `${fromDate}T00:00:00`;
        if (toDate) params.to_date = `${toDate}T23:59:59`;
      }
   
           if (noteType?.value === 'telecaller_sale') {
        if (fromDate) params.from_date = `${fromDate}T00:00:00`;
        if (toDate) params.to_date = `${toDate}T23:59:59`;
      }
   

      console.log('Request params:', params);

      const result = await axios.get(
        'https://api.skyguard.group/api/get-service-report',
        { params }
      );

      setfetchData(result.data.result || []);
      console.log('Report result:', result.data.result);

    } catch (error) {
      console.error('Error fetching report:', error);
    }
  };

     const handleExportExcel = () => {
        const table = document.getElementById("exportTable");
      
        if (!table) return;
      
        const worksheet = XLSX.utils.table_to_sheet(table);
        const workbook = XLSX.utils.book_new();
      
        XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
      
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
      
        const data = new Blob([excelBuffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
      
        saveAs(data, "Service_Report.xlsx");
      };

  return (
    <>

      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
 <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
          <h3 className='my-3 fw-bold fs-5 golos'>Report</h3>


          <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}

                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
              {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
                 <FaSearch size={26} className="ms-1 text-primary"
                                            style={{ cursor: "pointer" }}
                                            title="Search"
                                            onClick={handleSearch}
                                          />
                            
                                          <MdLocalPrintshop
                                            size={26}
                                            className="ms-1 text-success"
                                               onClick={handleExportExcel}
                                            style={{ cursor: "pointer" }}
                                            title="Print "
                                          />
            </div>
          </div>




{noteType?.value === 'service_history' && (
  <div className="row mb-3">

    {/* Technician Filter */}
    <div className="col-md-3">
      <select
        className="form-select"
        value={selectedTechnician}
        onChange={(e) => setSelectedTechnician(e.target.value)}
      >
        <option value="">All Technicians</option>
        {technicians.map((t, i) => (
          <option key={i} value={t.id}>
            {t.name}
          </option>
        ))}
      </select>
    </div>

    {/* Party Filter */}
    <div className="col-md-3">
      <select
        className="form-select"
        value={selectedParty}
        onChange={(e) => setSelectedParty(e.target.value)}
      >
        <option value="">All Parties</option>
        {parties.map((p, i) => (
          <option key={i} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>
    </div>

  </div>
)}

          <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>



            {noteType?.value === 'service_history' ? (


              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Ref Doc</th>
                    <th>Party Name</th>
                    <th>Party Phone</th>
                    <th>Party Address</th>
                    <th>Technician Name </th>
                    <th>Status</th>
                    <th>Created Date</th>
                    <th> Done On</th>
                    <th>Machine Name</th>
                    <th>Part Used</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData
                         .filter(item => {
    if (noteType?.value !== 'service_history') return true;

    const matchTech = selectedTechnician
      ? item.technician_id === selectedTechnician
      : true;

    const matchParty = selectedParty
    ? Number(item.party_id || 0) === Number(selectedParty)
    : true;

    return matchTech && matchParty;
  })
                    .map((item, idx) => {

  let pmsItems = [];
    try {
      pmsItems = item.pms_items ? JSON.parse(item.pms_items) : [];
    } catch {
      pmsItems = [];
    }

    // ✅ Parse Complaint items
    let complaintItems = [];
    try {
      complaintItems = item.complaint_items ? JSON.parse(item.complaint_items) : [];
    } catch {
      complaintItems = [];
    }

      let itemDetails = [];
    try {
      itemDetails = item.item_details ? JSON.parse(item.item_details) : [];
    } catch {}

    // ✅ Merge both
    const allItems = [
      ...pmsItems,
      ...complaintItems
    ];

    // ✅ Extract only names
    const itemNames = allItems
      .map(i => i.name)
      .filter(Boolean)
      .join(", ");
                      return (
                        <tr key={idx}>
                          <td>{item.pms_ref_doc || `CMP/${item.complaint_id}/${item.complaint_branch}`}</td>
                          <td>{item.party_name}</td>
                          <td>{item.part_phone || item.party_mobile} </td>
 <td className="text-wrap " >
  {item.party_address}
</td>
                          <td>{item.employee_first_name} {item.employee_middle_name}  {item.employee_last_name} - {item.
                            technician_id
                          } </td>
                          <td>{item.status}</td>
                          <td>{item.pms_created_date  || item.complaint_date}</td>
                          <td>{item.visitDate} </td>

                           <td >
          {itemNames || "-"}
        </td>


         <td>
  {itemDetails.length > 0
    ? itemDetails.map((i, index) => (
        <div key={index}>
          {i.name} ( <b>Qty:</b> {i.qty || 1})
        </div>
      ))
    : "-"}
</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="4">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>) : noteType?.value === 'call_detail' ? (
               
                <table className="table table-bordered table-striped table-hover text-center align-middle">
                  <thead className='table-info' >
                    <tr>
                      <th>Ref Doc</th>
                      <th>Party Name</th>
                      <th>Party Address</th>
                      <th>Tech ID</th>
                      <th>Technician Name </th>
                    
                      <th>Assigned  Date</th>
                      <th>Completion Date</th>
                        <th>Visit Status</th>
                        <th>Complaint Type</th>
                        <th>Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(fetchData) && fetchData.length > 0 ? (
                      fetchData.map((item, idx) => (
                        <tr key={idx}>
                          <td>{`CMP/${item.complaint_id}/${item.compnait_by_branch}`} </td>
                          <td>{item.party_name}</td>
                          <td className='word-wrap'>{item.party_address} </td>
                          <td>{item.technician_id} </td>
                          <td>{item.employee_first_name} {item.employee_middle_name}  {item.employee_last_name}  </td>
                        
                          <td>{item.assignedDate}</td>
                          <td>{item.visitDate} </td>
                            <td>{item.status}</td>
                            <td> {item.complaint_type_name} </td>
                            <td className='word-wrap'>{item.remark} </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">No  data found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) 
              
              :
              
   noteType?.value === 'employee_collection' ? (
  <table className="table table-bordered table-striped table-hover text-center align-middle">
    <thead className="table-info">
      <tr>
        <th>Payment Ref Doc</th>
        <th>Payment Type</th>
        <th>Payment Date </th>
        <th>Ref Doc</th>
        <th>Party Name</th>
        <th>Allocated Amount</th>
        <th>Balance Amount</th>
        <th>Total Amount</th>
  
        <th>Remark</th>

        <th>Net Collection</th>
      </tr>
    </thead>

    <tbody>
      {Array.isArray(fetchData) && fetchData.length > 0 ? (
        fetchData.map((item, idx) => {

          const parsedTableRow = item.tableRow
            ? JSON.parse(JSON.parse(item.tableRow))
            : [];

          return (
            <tr key={idx}>

           <td>
  {item.payment_type === 'bank_receipt' ? 'BR' : 'CR'}/{item.inv_no}/{item.branchName}
</td>
              <td>{item.payment_type}</td>

              <td>{item.payment_date} </td>

              {/* show first allocation (or loop if multiple) */}
              <td>
                {parsedTableRow[0]?.allocation?.map((a, i) => (
                  <div key={i}>{a.ref_doc}</div>
                ))}
              </td>

              <td>
                {parsedTableRow[0]?.allocation?.map((a, i) => (
                  <div key={i}>{a.party}</div>
                ))}
              </td>

              <td>
                {parsedTableRow[0]?.allocation?.map((a, i) => (
                  <div key={i}>{a.allocated_amount}</div>
                ))}
              </td>

              <td>
                {parsedTableRow[0]?.allocation?.map((a, i) => (
                  <div key={i}>{a.balance_amount}</div>
                ))}
              </td>
 <td>
                {parsedTableRow[0]?.allocation?.map((a, i) => (
                  <div key={i}>{a.allocated_amount}</div>
                ))}
              </td>

            

              <td>{item.remark}</td>
            
              <td>{item.amount}</td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan="10">No data found</td>
        </tr>
      )}
    </tbody>
  </table>
) 
              
              :  noteType?.value === 'employee_performance' ? (
               
                <table className="table table-bordered table-striped table-hover text-center align-middle">
                  <thead className='table-info' >
                    <tr>
                      <th> Doc Type</th>
                      <th>Emp ID</th>
                      <th>Done</th>
                      <th>Amount</th>
                      <th>Bill Amount</th>
                      <th>Date</th>
                      <th>Party Address</th>
                      <th>Tech ID</th>
                      <th>Technician Name </th>
                    
                      <th>Assigned  Date</th>
                      <th>Completion Date</th>
                        <th>Visit Status</th>
                        <th>Complaint Type</th>
                        <th>Emp ID</th>
                        <th>Employee Name</th>
                        <th>Designation</th>
                        <th>Net Collection</th>
                        <th>Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(fetchData) && fetchData.length > 0 ? (
                      fetchData.map((item, idx) => (
                        <tr key={idx}>
                          <td>{`CMP/${item.complaint_id}/${item.compnait_by_branch}`} </td>
                          <td>{item.party_name}</td>
                          <td className='word-wrap'>{item.party_address} </td>
                          <td>{item.technician_id} </td>
                          <td>{item.employee_first_name} {item.employee_middle_name}  {item.employee_last_name}  </td>
                        
                          <td>{item.assignedDate}</td>
                          <td>{item.visitDate} </td>
                            <td>{item.status}</td>
                            <td> {item.complaint_type_name} </td>
                            <td className='word-wrap'>{item.remark} </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">No  data found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )
              : noteType?.value === 'pending_pms_call' ? (
             
                <table className="table table-bordered table-striped table-hover text-center align-middle">
                  <thead className='table-info' >
                    <tr>
                      <th>PMS ID</th>
                      <th>Ref Doc</th>
                      <th>Party Name</th>
                     <th>Contact</th> 
                     <th>Address</th>
                      <th>Created Date</th>
                    <th>Tehcnician ID</th>
                    <th>Assigned Date</th>
                    
                    </tr>
                  </thead>
                  <tbody>
                {Array.isArray(fetchData) && fetchData.length > 0 ? (
  fetchData.map((item, idx) => {

    let visits = [];

    // ✅ Parse visits safely
    try {
      visits = item.visits ? JSON.parse(item.visits) : [];
    } catch (e) {
      visits = [];
    }

    // ✅ Apply your conditions
    const shouldShow =
      !visits || visits.length === 0 ||
      visits.some(v =>
        v.technician_id &&
        (!v.visitDate || !v.status || !v.location)
      );

    if (!shouldShow) return null;

       const visit = visits[0] || {};

    // ✅ Check technician
    const hasTechnician = visit?.technician_id;

    return (
      <tr key={idx}>
        <td>{item.pms_id} </td>
        <td>{item.pms_ref_doc}</td>
        <td>{item.party_name}</td>
        <td>{item.party_phone}</td>

        <td style={{
          maxWidth: "250px",
          whiteSpace: "normal",
          wordBreak: "break-word",
          verticalAlign: "top"
        }}>
          {item.party_address}
        </td>

        <td>{item.pms_created_date}</td>

          <td>{hasTechnician ? visit.technician_id : ''}</td>

        {/* ✅ Assigned Date */}
        <td>{hasTechnician ? visit.assignedDate : ''}</td>
      </tr>
    );
  })
) : (
  <tr>
    <td colSpan="5">No pending PMS call</td>
  </tr>
)}
                  </tbody>
                </table>
              ) : noteType?.value === 'paid_service_call' ? (
             
                <table className="table table-bordered table-striped table-hover text-center align-middle">
                  <thead className='table-info' >
                    <tr>
                      <th>Ref Doc</th>
                      <th>Type</th>
                      <th>Party Name</th>
                     <th>Contact</th> 
                     <th>Address</th>
                      <th>Assigned Date</th>
                      <th>Visit Date</th>
                      <th>Status</th>
                      <th>Entered By</th>
                    
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(fetchData) && fetchData.length > 0 ? (
                      fetchData.map((item, idx) => (
                        <tr key={idx}>
                         <td>{`CPM/${item.complaint_id}/${item.complaint_by_branch}`}</td>
                         <td>{item.complaint_type_name} </td>
                          <td>{item.party_name}</td>
                          <td>{item.party_phone} </td>
<td style={{
  maxWidth: "250px",   
  whiteSpace: "normal", 
  wordBreak: "break-word", 
  verticalAlign: "top"
}}>
  {item.party_address}
</td>


                          <td>{item.assignedDate}</td>
                          <td>{item.visitDate}</td>
                          <td>{item.complaint_status} </td>
                          <td>{item.added_by_first} {item.added_by_middle}  {item.added_by_last} </td>                         
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">No  pending pms call </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              ) :


              noteType?.value === 'schedule_technician' ? (
             
                <table className="table table-bordered table-striped table-hover text-center align-middle">
                  <thead className='table-info' >
                    <tr>
                      <th> No</th>
                      <th>Date</th>
                      <th>Party Name</th>
                     <th>Contact</th> 
                     <th>Address</th>
                  
                    <th>Tehcnician ID</th>
                    <th>technician Name</th>
                    <th>Assigned Date</th>
              
                    <th>Type</th>
                    
                    </tr>
                  </thead>
      <tbody>
{Array.isArray(fetchData) && fetchData.length > 0 ? (
  fetchData.map((item, idx) => {

    // ✅ Show only if technician exists AND visitDate is null/empty
    const shouldShow =
      item.technician_id &&
      (!item.visitDate || item.visitDate === null || item.visitDate === '');

    if (!shouldShow) return null;

    return (
      <tr key={idx}>
        <td>{`CMP/${item.complaint_id}/${item.complaint_branch}`}</td>

        <td>{item.complaint_date}</td>

        <td>{item.party_name}</td>

        <td>{item.party_phone}</td>

        <td style={{
          maxWidth: "250px",
          whiteSpace: "normal",
          wordBreak: "break-word",
          verticalAlign: "top"
        }}>
          {item.party_address || ''}
        </td>

        {/* Technician */}
        <td>{item.technician_id || ''}</td>
        <td>{item.tech_first || ''} {item.tech_middle || ''}  {item.tech_last || ''} </td>

        {/* Assigned Date */}
        <td>{item.assignedDate || ''}</td>

     

        <td>{item.status_type || ''}</td>
      </tr>
    );
  })
) : (
  <tr>
    <td colSpan="9">No scheduled technician</td>
  </tr>
)}
</tbody>
                </table>
              ) :
              
               noteType?.value === 'telecaller_sale' ? (
             
                <table className="table table-bordered table-striped table-hover text-center align-middle">
                  <thead className='table-info' >
                    <tr>
                      <th>Call No</th>
                      <th>Call  Date</th>
                      <th>Invoice</th>
                      <th>Invoice Date</th>
                      <th>Party Name</th>
                     <th>Contact</th> 
                     <th>Address</th>
                    <th>Employee Name</th>
                    <th>Call Status</th>
                    
                    </tr>
                  </thead>
     <tbody>
{Array.isArray(fetchData) && fetchData.length > 0 ? (
  fetchData.map((item, idx) => {

    const callId = item.ref_doc || item.complaint_id || '';
    const callDate = item.date || item.complaint_date || '';
    const refDoc = item.ref_doc_label || item.ref_doc || '';
    const invoiceDate = item.quotation_date || item.start_date ||  '';
    const partyName = item.party_name || item.party || '';
    const grandTotal = item.raw?.grand_total || item.grand_total || 0;
    const addedBy = item.raw?.added_by || item.added_by || '';
    const status = item.status_type || item.complaint_status || '';

    return (
      <tr key={idx}>
        
        {/* Call ID */}
        <td>{`CMP/${callId}/${item.complaint_branch }`}</td>

        {/* Call Date */}
        <td>{callDate}</td>

        {/* AMC / Repair Ref Doc */}
        <td>{refDoc}</td>

        {/* Invoice Date */}
        <td>{invoiceDate}</td>

        {/* Party Name */}
        <td>{partyName}</td>

        {/* Grand Total */}
        <td>{grandTotal}</td>

        {/* Added By */}
        <td>{addedBy}</td>

        {/* Status */}
        <td>{status}</td>

      </tr>
    );
  })
) : (
  <tr>
    <td colSpan="8">No data found</td>
  </tr>
)}
</tbody>
                </table>
              ) 
              
              : (
     
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Party Name</th>
                    <th>Technician Name </th>
                    <th>Complaint Type</th>
                    <th>Status</th>
                    <th>Created Date</th>
                    <th>Visit Date</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                      fetchData.map((item, idx) => (
                        <tr key={idx}>
                  
                          <td>{item.party_name}</td>
                          <td>{item.employee_first_name} {item.employee_middle_name}  {item.employee_last_name} - {item.
                            technician_id
                          } </td>
                          <td>{item.complaint_type_name}</td>
                          <td>{item.status} </td>
                          <td>{item.complaint_date}</td>
                          <td>{item.visitDate} </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">No oc call found</td>
                      </tr>
                    )}
                </tbody>
              </table>
            )}


          </div>

        </div>
      </div>
    </>
  )
}

export default Service_ReportPMS